import React, { useState } from 'react';
import {
  Link,
  Link as RouterLink,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {
  Typography,
  Divider,
  Select,
  InputLabel,
  MenuItem,
  Button,
  TextField,
} from '@mui/material';
import { hashPassword } from '../../../constant/constant';
import { handleCustomerLogin } from '../../../stores/services/authApis/index';
import { useAlert } from '../../../components/Notification';
import { useForm } from 'react-hook-form';

const CustomerLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const defaultMobileNo = state?.mobileNo;

  const showAlert = useAlert();
  const [mobileNo, setMobileNo] = useState('');
  const {
    register,
    formState: { errors },
    handleSubmit,
    clearErrors,
  } = useForm();

  const login = async (data: any) => {
    await handleCustomerLogin({
      mobileNo: data.mobilenumber,
    })
      .then((response) => {
        navigate('/verification', {
          state: { mobileNo: data.mobilenumber, page: 'signIn' },
        });
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  //assign mobilenumber
  const handleMobileNumberChange = (event: { target: any; type?: any }) => {
    const inputValue = event.target.value.replace(/\D/g, '');
    event.target.value = inputValue;
    // Update form state with the cleaned value
    register('mobilenumber').onChange(event);
  };

  //remove country code error
  const handleCountryCodeChange = (event: { target: { value: any } }) => {
    if (event.target.value) {
      clearErrors('countrycode');
    }
  };

  // Utility function to safely get the error message
  const getErrorMessage = (error: any) => {
    if (!error) return '';
    if (typeof error?.message === 'string') return error.message;
    return 'Invalid input';
  };

  return (
    <>
      <form onSubmit={handleSubmit(login)}>
        <section className="signup_container">
          <div className="signup_header">
            <h4>Sign in</h4>
          </div>
          <div className="signup_inputfield_containet">
            <div>
              <InputLabel htmlFor="mobile">Mobile Number</InputLabel>
              <div className="signup_inputfield-mobile">
                <Select
                  className="form-countrycode"
                  {...register('countrycode', {
                    required: 'Country Code is required',
                  })}
                  variant="outlined"
                  error={errors.countrycode ? true : false}
                  onChange={handleCountryCodeChange}
                  defaultValue="+91"
                >
                  <MenuItem value="+91">+91</MenuItem>
                </Select>
                <TextField
                  fullWidth
                  {...register('mobilenumber', {
                    required: 'Mobile Number is required',
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: 'Phone number must be 10 digits',
                    },
                  })}
                  inputProps={{
                    maxLength: 10,
                  }}
                  onChange={handleMobileNumberChange}
                  defaultValue={defaultMobileNo && defaultMobileNo}
                  variant="outlined"
                  error={errors.mobilenumber ? true : false}
                />
              </div>
              {errors.mobilenumber && (
                <Typography variant="body2" className="customer_login_error">
                  {getErrorMessage(errors?.mobilenumber)}
                </Typography>
              )}
              {!errors.mobilenumber && errors.countrycode && (
                <Typography variant="body2" className="customer_login_error">
                  {getErrorMessage(errors?.countrycode)}
                </Typography>
              )}
            </div>
          </div>

          <div className="signup_submit">
            <Button type="submit">Get OTP </Button>
            <h5>
              Have an account?
              <span>
                <Link to="/signup"> Sign up</Link>
              </span>
            </h5>
          </div>
        </section>
      </form>
    </>
  );
};

export default CustomerLogin;
